import MapType from './control/MapType';
import RoadType from "./control/RoadType";
import GoogleMapLayer from './layer/GoogleMap';
import GoogleMapRoadLayer from "./layer/GoogleMapRoad";
import GoogleMapSatelliteLayer from "./layer/GoogleMapSatellite";
import GoogleMapSatelliteRoadLayer from "./layer/GoogleMapSatelliteRoad";
import Chb2FairwayLayer from './layer/Chb2Fairway';
import Chb2BerthMapLayer from './layer/Chb2BerthMap';
import GoogleMapLabelLayer from './layer/GoogleMapLabel';
import GoogleMapSatelliteLabelLayer from './layer/GoogleMapSatelliteLabel';

export function updateMapLayers(map) {
    let mapTypeControl = map.getControls().getArray().find(l => l.get('name') === MapType.controlName);
    let mapType = mapTypeControl && mapTypeControl.get("mapType") || "map";
    let roadTypeControl = map.getControls().getArray().find(l => l.get('name') === RoadType.controlName);
    let roadType = roadTypeControl && roadTypeControl.get("roadType") || "fairway";

    switch (mapType + "-" + roadType) {
        case 'map-fairway':
            setLayerVisible(map, GoogleMapLayer.layerName, true);
            setLayerVisible(map, GoogleMapRoadLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteRoadLayer.layerName, false);
            setLayerVisible(map, Chb2FairwayLayer.layerName, true);
            setLayerVisible(map, Chb2BerthMapLayer.layerName, false);
            setLayerVisible(map, GoogleMapLabelLayer.layerName, true);
            setLayerVisible(map, GoogleMapSatelliteLabelLayer.layerName, false);
            break;
        case 'satellite-fairway':
            setLayerVisible(map, GoogleMapLayer.layerName, false);
            setLayerVisible(map, GoogleMapRoadLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLayer.layerName, true);
            setLayerVisible(map, GoogleMapSatelliteRoadLayer.layerName, false);
            setLayerVisible(map, Chb2FairwayLayer.layerName, true);
            setLayerVisible(map, Chb2BerthMapLayer.layerName, false);
            setLayerVisible(map, GoogleMapLabelLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLabelLayer.layerName, true);
            break;
        case 'map-berth':
            setLayerVisible(map, GoogleMapLayer.layerName, true);
            setLayerVisible(map, GoogleMapRoadLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteRoadLayer.layerName, false);
            setLayerVisible(map, Chb2FairwayLayer.layerName, false);
            setLayerVisible(map, Chb2BerthMapLayer.layerName, true);
            setLayerVisible(map, GoogleMapLabelLayer.layerName, true);
            setLayerVisible(map, GoogleMapSatelliteLabelLayer.layerName, false);
            break;
        case 'satellite-berth':
            setLayerVisible(map, GoogleMapLayer.layerName, false);
            setLayerVisible(map, GoogleMapRoadLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLayer.layerName, true);
            setLayerVisible(map, GoogleMapSatelliteRoadLayer.layerName, false);
            setLayerVisible(map, Chb2FairwayLayer.layerName, false);
            setLayerVisible(map, Chb2BerthMapLayer.layerName, true);
            setLayerVisible(map, GoogleMapLabelLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLabelLayer.layerName, true);
            break;
        case 'map-road':
            setLayerVisible(map, GoogleMapLayer.layerName, true);
            setLayerVisible(map, GoogleMapRoadLayer.layerName, true);
            setLayerVisible(map, GoogleMapSatelliteLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteRoadLayer.layerName, false);
            setLayerVisible(map, Chb2FairwayLayer.layerName, false);
            setLayerVisible(map, Chb2BerthMapLayer.layerName, false);
            setLayerVisible(map, GoogleMapLabelLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLabelLayer.layerName, false);
            break;
        case 'satellite-road':
            setLayerVisible(map, GoogleMapLayer.layerName, false);
            setLayerVisible(map, GoogleMapRoadLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLayer.layerName, true);
            setLayerVisible(map, GoogleMapSatelliteRoadLayer.layerName, true);
            setLayerVisible(map, Chb2FairwayLayer.layerName, false);
            setLayerVisible(map, Chb2BerthMapLayer.layerName, false);
            setLayerVisible(map, GoogleMapLabelLayer.layerName, false);
            setLayerVisible(map, GoogleMapSatelliteLabelLayer.layerName, false);
            break;
    }
}

function setLayerVisible(map, layerName, value) {
    let layer = map.getLayers().getArray().find(l => l.get('name') === layerName);
    return layer && layer.setVisible(value);
}

export function getLayers(mapSource) {
    return [
        new GoogleMapLayer({mapSource, visible: false}),
        new GoogleMapRoadLayer({mapSource, visible: false}),
        new GoogleMapSatelliteLayer({mapSource, visible: false}),
        new GoogleMapSatelliteRoadLayer({mapSource, visible: false}),
        new Chb2FairwayLayer({visible: false}),
        new Chb2BerthMapLayer({visible: false}),
        new GoogleMapLabelLayer({mapSource, visible: false}),
        new GoogleMapSatelliteLabelLayer({mapSource, visible: false}),
    ];
}
